import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { LimitAmounts } from '@base/src/app/models/renditions/renditionMovement.model';
import { TableHeader } from '@base/src/app/models/tableheader.model';

export interface MovementPending {
  type: string;
  cashBox: string;
  currency: string;
  amount: number | string;
  [key: string]: string | number;
}
export type ListMovementPendingKey = keyof MovementPending;
@Component({
  selector: 'app-rendition-movement-pending-amount',
  templateUrl: './rendition-movement-pending-amount.component.html',
  styleUrls: ['./rendition-movement-pending-amount.component.scss'],
})
export class RenditionMovementPendingAmountComponent implements OnInit {
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  value: undefined | LimitAmounts;

  listMovement: MovementPending[] = [];
  listMovementKey: ListMovementPendingKey[] = [];

  tableHeader: TableHeader[] = [
    {
      id: 'type',
      text: 'Tipo',
      percentageWidth: 20,
      isOrderByVisible: false,
    },
    {
      id: 'cash-boxes',
      text: 'Caja',
      percentageWidth: 40,
      isOrderByVisible: false,
    },
    {
      id: 'currency',
      text: 'Moneda',
      percentageWidth: 20,
      isOrderByVisible: false,
    },
    {
      id: 'amount',
      text: 'Monto',
      percentageWidth: 20,
      isOrderByVisible: false,
    },
  ];

  ngOnInit(): void {
    if (this.value) {
      const addMov = (
        amount: null | number,
        type: number,
        currency: string
      ) => {
        if (amount && amount > 0) {
          const item: MovementPending = {
            type: type == 0 ? 'Ingreso' : 'Egreso',
            cashBox: 'Caja de seguridad',
            currency: currency,
            amount: amount.toLocaleString('es-AR'),
          };
          this.listMovement.push(item);
        }
      };

      addMov(this.value.income.commissionsLocal, 0, '$');
      addMov(this.value.income.commissionsUSD, 0, 'U$S');
      addMov(this.value.income.ivaLocal, 0, '$');
      addMov(this.value.income.ivaUSD, 0, 'U$S');

      addMov(this.value.expense.commissionsLocal, 1, '$');
      addMov(this.value.expense.commissionsUSD, 1, 'U$S');
      addMov(this.value.expense.ivaLocal, 1, '$');
      addMov(this.value.expense.ivaUSD, 1, 'U$S');

      this.listMovementKey = Object.keys(this.listMovement[0]);
    }
  }
}
